import React, { useEffect, useState } from 'react';
// import palette from '../../../lib/styles/palette';
import { Input } from '../TowerEditor';
import { UNITWEIGHT_VOLUME_MAIN, UNITWEIGHT_VOLUME_SUB, UNITWEIGHT_VOLUME_ROOF } from './constants';
import { useDispatch } from 'react-redux';
import { changeBody, summaryWeight } from '../../../modules/tower/towerWriteSlice';
import { getItemTotalWeight } from './weightSummary';

const SizeForm = ({ size }) => {
    const dispatch = useDispatch();
    const [newSize, setNewSize] = useState(size || { main: {}, sub: {}, roof: {} });

    const handleChange = (e) => {
        const { name, value } = e.target;
        const strArray = name.split('.');
        const category = strArray[0];
        const key = strArray[1];

        setNewSize((prev) => ({
            ...prev,
            [category]: {
                ...prev[category],
                [key]: value,
            },
        }));
    };

    /* 내부 계산. 메인 구조물 */
    useEffect(() => {
        if (!newSize?.main?.length || !newSize?.main?.width || !newSize?.main?.height) {
            setNewSize((prev) => ({
                ...prev,
                main: {
                    ...prev['main'],
                    heightFactor: '',
                    volume: '',
                    unitWeight: '',
                    weight: '',
                },
            }));
            return;
        }
        const heightFactor = getHeightFactor(newSize.main.height);
        const volume = getVolume(newSize.main.length, newSize.main.width, newSize.main.height);
        const unitWeight = UNITWEIGHT_VOLUME_MAIN;
        const weight = Math.ceil(volume * unitWeight * heightFactor);
        // const roofVolume = getVolume(newSize.main.length, newSize.main.width, newSize.main.roofHeight);
        // const roofWeight = Math.ceil(roofVolume * unitWeight);

        setNewSize((prev) => ({
            ...prev,
            main: {
                ...prev['main'],
                heightFactor: heightFactor || '',
                volume: volume || '',
                unitWeight: unitWeight || '',
                weight: weight || '',
            },
        }));
    }, [newSize?.main?.length, newSize?.main?.width, newSize?.main?.height, newSize?.main?.roofHeight]);

    /* 내부 계산. 루프 구조물 */
    useEffect(() => {
        if (!newSize?.main?.length || !newSize?.main?.width || !newSize?.roof?.height) {
            setNewSize((prev) => ({
                ...prev,
                roof: {
                    ...prev['roof'],
                    volume: '',
                    unitWeight: '',
                    weight: '',
                },
            }));
            return;
        }
        const volume = getVolume(newSize.main.length, newSize.main.width, newSize.roof.height);
        const unitWeight = UNITWEIGHT_VOLUME_ROOF;
        const weight = Math.ceil(volume * unitWeight);

        setNewSize((prev) => ({
            ...prev,
            roof: {
                ...prev['roof'],
                volume: volume || '',
                unitWeight: unitWeight || '',
                weight: weight || '',
            },
        }));
    }, [newSize?.main?.length, newSize?.main?.width, newSize?.roof?.height]);

    /* 내부 계산. 서브 구조물 */
    useEffect(() => {
        if (!newSize?.sub?.length || !newSize?.sub?.width || !newSize?.sub?.height) {
            setNewSize((prev) => ({
                ...prev,
                sub: {
                    ...prev['sub'],
                    heightFactor: '',
                    volume: '',
                    unitWeight: '',
                    weight: '',
                },
            }));
            return;
        }
        const heightFactor = getHeightFactor(newSize.sub.height);
        const volume = getVolume(newSize.sub.length, newSize.sub.width, newSize.sub.height);
        const unitWeight = UNITWEIGHT_VOLUME_SUB;
        const weight = Math.ceil(volume * unitWeight);

        setNewSize((prev) => ({
            ...prev,
            sub: {
                ...prev['sub'],
                heightFactor: heightFactor || '',
                volume: volume || '',
                unitWeight: unitWeight || '',
                weight: weight || '',
            },
        }));
    }, [newSize?.sub?.length, newSize?.sub?.width, newSize?.sub?.height]);

    /* 함수 구역 시작 */
    const getVolume = (_width, _length, _height) => {
        const width = parseFloat(_width);
        const length = parseFloat(_length);
        const height = parseFloat(_height);

        return Math.ceil(width * length * height);
    };

    const getHeightFactor = (_height) => {
        const height = parseFloat(_height);
        let heightFactor;

        if (height > 20) {
            heightFactor = Math.round((height / 20) ** (2 / 3) * 100) / 100;
        } else {
            heightFactor = 1.0;
        }

        return heightFactor;
    };
    /* 함수 구역 끝 */

    /* 리덕스에 weightSum 쓰기 */
    useEffect(() => {

        dispatch(
            summaryWeight({
                key: 'size',
                value: getItemTotalWeight(newSize),
            }),
        );
    }, [newSize, dispatch]);

    /* 리덕스에 쓰기 */
    useEffect(() => {
        dispatch(
            changeBody({
                key: 'size',
                value: newSize,
            }),
        );
    }, [dispatch, newSize]);

    return (
        <>
            <tr>
                <td>Main Structure</td>
                <td style={{ width: '70px' }}>Width</td>
                <td style={{ width: '70px' }}>Length</td>
                <td style={{ width: '70px' }}>Height</td>
            </tr>
            <tr>
                <td className="indentation">Main</td>
                <td className="input-inside-td">
                    <Input name="main.width" value={newSize?.main?.width} onChange={handleChange} />
                </td>
                <td className="input-inside-td">
                    <Input name="main.length" value={newSize?.main?.length} onChange={handleChange} />
                </td>
                <td className="input-inside-td">
                    <Input name="main.height" value={newSize?.main?.height} onChange={handleChange} />
                </td>
                <td className="right-align" style={{ width: '70px' }}>
                    {newSize?.main?.volume}
                </td>
                <td className="unit-column">m3</td>
                <td className="right-align">{newSize?.main?.unitWeight}</td>
                <td className="right-align">{newSize?.main?.weight}</td>
            </tr>
            <tr>
                <td className="indentation">Roof</td>
                <td className="input-inside-td" colSpan={2}>
                    <span className="sub-description">※ Top Floor ~ Eave</span>
                </td>
                <td className="input-inside-td">
                    <Input name="roof.height" value={newSize?.roof?.height} onChange={handleChange} />
                </td>
                <td className="right-align" style={{ width: '70px' }}>
                    {isNaN(newSize?.roof?.volume) ? '' : newSize?.roof?.volume}
                </td>
                <td className="unit-column">m3</td>
                <td className="right-align">{newSize?.roof?.unitWeight}</td>
                <td className="right-align">{isNaN(newSize?.roof?.weight) ? '' : newSize?.roof?.weight}</td>
            </tr>
            <tr>
                <td className="indentation">Sub</td>
                <td className="input-inside-td">
                    <Input name="sub.width" value={newSize?.sub?.width} onChange={handleChange} />
                </td>
                <td className="input-inside-td">
                    <Input name="sub.length" value={newSize?.sub?.length} onChange={handleChange} />
                </td>
                <td className="input-inside-td">
                    <Input name="sub.height" value={newSize?.sub?.height} onChange={handleChange} />
                </td>
                <td className="right-align">{newSize?.sub?.volume}</td>
                <td>m3</td>
                <td className="right-align">{newSize?.sub?.unitWeight}</td>
                <td className="right-align">{newSize?.sub?.weight}</td>
            </tr>
            <tr>
                <td className="spacer"></td>
            </tr>
        </>
    );
};

export default SizeForm;
